/* eslint-disable vue/max-attributes-per-line */
<template>
  <div>
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <!-- Table Container Card -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <transition name="fade-bottom">
          <section>
            <!-- Datos cargados -->
            <!-- <b-card-header class="pb-0">
              <b-card-title />
              <b-card-text class="font-small-2 mr-25 mb-0">
                Datos cargados <b>{{ updatedAt }}</b>
              </b-card-text>
            </b-card-header> -->

            <!-- Table Top -->
            <filtro-planes
              :plan-filter.sync="configRequest.wsParams.plan"
              :status-filter.sync="configRequest.status"
              :search-query.sync="searchQuery"
              :per-page.sync="perPage"
              :per-page-options="perPageOptions"
            />

            <b-table
              ref="refDataListTable"
              class="position-relative"
              :items="fetchData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No se encontraron resultados, utilice los filtros."
              :sort-desc.sync="isSortDirDesc"
            >

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <!-- Marcar Factura -->
                  <feather-icon
                    v-show="userRol.id == 5 && data.item.status == 'AUT'"
                    :id="`invoice-row-${data.item.id}-auth-icon`"
                    icon="CheckCircleIcon"
                    size="16"
                    class="mr-1 cursor-pointer"
                    @click="authTransaccion(data.item)"
                  />
                  <!-- reject transaccion -->
                  <feather-icon
                    v-show="userRol.id == 5 && data.item.status == 'AUT'"
                    :id="`invoice-row-${data.item.id}-reject-icon`"
                    icon="Trash2Icon"
                    class="mr-1 cursor-pointer"
                    size="16"
                    @click="reject(data.item)"
                  />
                  <!-- icon for download file -->
                  <a
                    @click="downloadFile(data.item.rutaDoc + data.item.extBase)"
                  >
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-view-icon`"
                      icon="PaperclipIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </a>
                </div>
              </template>

              <!-- detalles tab -->
              <template #cell(show_details)="row">
                <b-form-checkbox
                  v-model="row.detailsShowing"
                  plain
                  class="vs-checkbox-con"
                  @change="row.toggleDetails"
                >
                  <span class="vs-checkbox">
                    <span class="vs-checkbox--check">
                      <i class="vs-icon feather icon-check" />
                    </span>
                  </span>
                  <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                </b-form-checkbox>
              </template>
              <!-- detalle de row -->
              <template #row-details="row">
                <b-card>
                  <b-row class="mb-2">
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Aportacion : </strong>{{ row.item.monto }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Forma_Pago: </strong>{{ row.item.forma_pago }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Metodo_Pago: </strong>{{ row.item.metodoPago }}
                    </b-col>
                    <!-- next level -->
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Aprob_Admin : </strong>{{ (row.item.aprobadoAdmin == 1) ? 'SI': 'Pendiente' }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Fecha_Admin : </strong>{{ row.item.fechaAprobAdmin }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Fecha_Contab : </strong>{{ row.item.fechAprobContab }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Comentarios : </strong><br>{{ row.item.comentarios }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Observaciones : </strong><br>{{ row.item.observaciones }}
                    </b-col>
                    <b-col
                      md="4"
                      class="mb-1"
                    >
                      <strong>Obser_Factura : </strong><br>{{ row.item.fac_observaciones }}
                    </b-col>
                  </b-row>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                  >
                    Menos Detalles
                  </b-button>
                </b-card>
              </template>

              <!-- Column: Invoice Status -->
              <template #cell(status)="row">
                <b-badge :variant="frmstatus(row.item.status).color">
                  {{ frmstatus(row.item.status).text }}
                </b-badge>
              </template>

              <!-- Column: Issued Date -->
              <template #cell(fecha_pago)="row">
                <span class="text-nowrap">
                  {{ row.item.fecha_pago }}
                </span>
              </template>

              <!-- ver factura -->
              <template #cell(factura)="row">
                <span class="text-nowrap">
                  <b-badge
                    :class="(row.item.factura) ? 'cursor-pointer' : '' "
                    :variant="(row.item.factura) ? 'light-primary' : '' "
                    @click="PrintFactura(row.item)"
                  >{{ (row.item.factura) ? 'Ver Factura' : 'N/A' }}</b-badge>
                </span>
              </template>

            </b-table>
            <!-- footer -->
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>

              </b-row>
            </div>
          </section>
        </transition>
      </b-card>
    </b-overlay>
    <!-- Marcar transaccion revisada -->
    <b-modal
      v-model="modContabilidad"
      size="lg"
      title="Marcar factura finalizada"
      no-body
      @hide="modContabilidad = false"
    >
      <b-col
        lg="12"
        md="12"
      >
        <b-alert
          class="mb-1"
          show
          variant="dark"
        >
          <div class="alert-body">
            <span>No. <b>#{{ setItem.id }}</b>, Aportación: <b>${{ setItem.monto }}</b>, Registrado: <b>${{ setItem.fecha_pago }}</b>.</span>
          </div>
        </b-alert>
        <b-input-group>
          <b-form-textarea
            id="txtcomentariosConta"
            v-model="txtcomentariosConta"
            placeholder="Comentarios finales sobre la factura realizada."
            rows="3"
            no-resize
          />
        </b-input-group>
        <div class="d-block mt-2 text-center">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :disabled="(setItem.status != 'AUT') ? true : false"
            class="mr-2"
            @click="procederAuth()"
          >
            <feather-icon
              :icon="(flagproceder) ? 'ClockIcon' : 'ArrowRightIcon'"
              class="mr-50"
            />
            <b-spinner
              v-show="flagproceder"
              small
              type="grow"
            />
            {{ (flagproceder) ? 'Trabajando...': 'Proceder' }}
          </b-button>
        </div>
      </b-col>
      <template #modal-footer>
        <div class="w-100">
          <b-badge variant="light-secondary">
            {{ (setItem.factura !== null) ? 'La transacción cuenta con factura se marcara la fecha y comentarios finales' : 'Esta transaccion no requiere factura' }}
          </b-badge>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="modContabilidad=false"
          >
            Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- Cancelar transaccion -->
    <b-modal
      v-model="flagreject"
      size="lg"
      title="¿Cancelar transacción?"
      no-body
      hide-footer
      @hide="flagreject = false"
    >
      <b-col
        lg="12"
        md="12"
      >
        <b-alert
          class="mb-1"
          show
          variant="dark"
        >
          <div class="alert-body">
            <span>No. <b>#{{ setItem.id }}</b>,  Aportación: $<b>{{ setItem.precioFinal }}</b>, Registrado: <b>${{ setItem.fecha }}</b>, Status: <b>{{ frmstatus(setItem.status).text }}</b>.</span>
          </div>
        </b-alert>
        <b-input-group prepend="Motivo">
          <b-form-textarea
            id="txtobservaciones"
            v-model="txtobservaciones"
            placeholder="Ingrese el motivo de cancelación."
            rows="3"
            no-resize
          />
        </b-input-group>
        <div class="d-block mt-2 text-center">
          <b-button
            v-show="setItem.status == 'AUT'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="mr-2"
            @click="procederCancelacion()"
          >
            <feather-icon
              :icon="(flagproceder) ? 'ClockIcon' : 'ArrowRightIcon'"
              class="mr-50"
            />
            <b-spinner
              v-show="flagproceder"
              small
              type="grow"
            />
            {{ (flagproceder) ? 'Trabajando...': 'Proceder' }}
          </b-button>
          <b-alert
            v-show="setItem.status=='CAN'"
            class="mt-2"
            show
            variant="warning"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertTriangleIcon"
              />
              <span class="ml-25">Esta solicitud ya fue cancelada.</span>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  // BCardHeader,
  // BCardTitle,
  // BCardText,
  BRow,
  BCol,
  BAlert,
  BInputGroup,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BSpinner,
  BFormTextarea,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  frmstatus, lastUpdate,
} from '@core/utils/filter'
import { formhttp, shipcode } from '@core/utils/utils'
// import vSelect from 'vue-select'
import {
  onUnmounted, ref, onMounted, watch,
} from '@vue/composition-api'
import store from '@/store'
import { rolesActions } from '@core/mixins/account-data/roles'
import { useToast } from 'vue-toastification/composition'
import hostname from '@core/utils/http/config-hostname'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// new table
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { configTableFacturacion } from './configFacturacion'

import filtroPlanes from '../components/compras/components/FiltroPlanes.vue' // '../components/FiltroPlanes.vue'

export default {
  components: {
    BCard,
    // BCardHeader,
    // BCardTitle,
    // BCardText,
    BRow,
    BCol,
    BAlert,
    BInputGroup,
    BTable,
    BBadge,
    BPagination,
    // vSelect,
    BButton,
    BSpinner,
    BFormTextarea,
    BOverlay,
    filtroPlanes,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  props: {
    frompublic: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      setItem: {},
      objcancelacion: {},
      objaprovacion: {},
      txtobservaciones: '',
      txtcomentariosConta: '',
    }
  },
  methods: {
    reject(obj) {
      this.setItem = obj
      this.flagreject = true
    },
    authTransaccion(obj) {
      this.setItem = obj
      this.modContabilidad = true
    },
    procederAuth() {
      // call api for upd revisara de acuerdo al rol que lo use
      this.objaprovacion = {
        action: 24, Idtran: this.setItem.id, factura: this.setItem.factura, observaciones: this.txtcomentariosConta, urol: this.userRol.id,
      }
      this.transReady(this.objaprovacion)
    },
    procederCancelacion() {
      // Prevent modal from closing
      if (this.txtobservaciones !== '' && this.txtobservaciones.length >= 15) {
        // call api for upd
        this.objcancelacion = {
          action: 8, tran: this.setItem.id, factura: this.setItem.factura, observaciones: this.txtobservaciones, urol: this.userRol.id,
        }
        this.transReject(this.objcancelacion)
      } else {
        this.$bvToast.toast('Es importante ingrese el motivo y debe ser mayor a 15 caracteres', {
          title: 'Atención',
          variant: 'warning',
          solid: true,
        })
      }
    },
  },
  setup() {
    const updatedAt = ref(lastUpdate())
    const INVOICE_APP_STORE_MODULE_NAME = 'app-facturacion'
    const toast = useToast()
    const modalShow = ref(false)
    const infofact = ref({})
    const infoPersona = ref({})
    const modContabilidad = ref(false)
    const flagproceder = ref(false)
    const flagreject = ref(false)
    const setTran = ref({})
    const { tableColumns, configRequest } = configTableFacturacion()
    const errorContent = ref({ filters: false, table: false })

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable, dataAux,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()

    /**
     * * Marcar transaccion completada
     * @param datos es un config [action: 24, Idtran: this.setItem.id, factura: this.setItem.factura, observaciones: null, urol: this.userRol.id]
     */
    const transReady = datos => {
      flagproceder.value = true
      store.dispatch('compras/postCompras', datos)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              text: response.resultado,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })
          if (response.status === 200) {
            refetchData(true)
            modContabilidad.value = false
          }
          flagproceder.value = false
        }, error => {
          flagproceder.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención aqui',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    /**
     * * Marcar como rechazada una transaccion
     * @param config valores [action: 8, trans: this.setItem.id, observaciones: this.txtobservaciones,]
     */
    const transReject = config => {
      flagproceder.value = true
      store.dispatch('compras/postCompras', config)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              text: response.resultado,
              icon,
              variant: label,
            },
          },
          { timeout: 8000 })
          if (response.status === 200) refetchData(true); flagreject.value = false
          flagproceder.value = false
        }, error => {
          flagproceder.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención aqui',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    const PrintFactura = objTran => {
      if (objTran.factura !== null) {
        setTran.value = objTran
        const config = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=700,height=800'
        const routeData = `${hostname().host}/app/imprimir/factura/${setTran.value.factura}/${setTran.value.orden}/${setTran.value.id}/`
        window.open(routeData, 'Imprimir Factura', config)
      }
    }

    //* Download files
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD + file}`, '_blank')
    }

    onMounted(() => {
    //   fetchCatalogosFilters() //* Load filter options (selects)
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
    })

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    // watch(configRequest.value, () => { refetchData(true) })
    watch([() => configRequest.value.wsParams.plan, () => configRequest.value.status], ([plan, status]) => {
      if (plan != null && status == null) {
        refetchData(true) // call api
      } else if (status != null && plan != null) {
        refetchData(false)
      } else if (plan == null && status == null) {
        refetchData(true) // seteamos vacia la lista
      }
    }, { immediate: true })

    return {
      downloadFile,
      // config for table
      fetchData,
      refDataListTable,
      dataAux,
      totalItems,
      searchQuery,
      configRequest,
      // items,
      // fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      // totalInvoices,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      // refInvoiceListTable,
      errorContent,

      // new tasks
      frmstatus,
      transReject,
      modalShow,
      // LoadFactura,
      transReady,
      shipcode,
      PrintFactura,
      lastUpdate,
      updatedAt,

      // flags
      modContabilidad,
      flagproceder,
      flagreject,
      isBusyTable,

      // params
      setTran,

      // values
      infofact,
      infoPersona,
    }
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
